import axios from 'axios';
import 'axios-retry';
import appConfig from '@/config';
import { encode } from 'js-base64';
export const baseURL = appConfig.apiURL;
export const create = (url = '', headers = {}) => {
    if (url === '') {
        url = baseURL;
    }
    const httpHeaders = {
        ...headers
    };
    if (window.brushApiToken) {
        httpHeaders['auth-token'] = window.brushApiToken;
    }
    // For local development only
    if (!appConfig.isProd && appConfig.insecureAuth) {
        // @ts-ignore
        httpHeaders['auth-token'] = encode(JSON.stringify(window.uData));
    }
    return axios.create({
        baseURL: url,
        headers: httpHeaders
    });
};
export const httpClient = create();
// axiosRetry(httpClient, { retries: 3, onRetry: (retry) => {
//     console.warn("retrying http request...")
// }, retryDelay: axiosRetry.exponentialDelay});
export const enableInterceptor = () => {
    httpClient.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        if (error?.message?.includes('canceled'))
            return Promise.resolve(true);
        console.warn('error on request', error);
        if (error?.response?.status === 401) {
            // console.error('there was an error on request.');
            window.location.replace('/login');
        }
        else {
            if (error?.response?.status === 504 || error?.response?.status === 503) {
                const retryDelay = new Promise((resolve, reject) => { });
                return httpClient(error.config);
            }
            return Promise.reject(error);
        }
    });
};
